import { render, staticRenderFns } from "./trader.vue?vue&type=template&id=a13e031e&scoped=true&"
import script from "./trader.vue?vue&type=script&lang=js&"
export * from "./trader.vue?vue&type=script&lang=js&"
import style0 from "./trader.vue?vue&type=style&index=0&id=a13e031e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13e031e",
  null
  
)

export default component.exports